var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg0(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "7.9375mm",
    height: "10.583mm",
    viewBox: "0 0 7.9375 10.583333",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-70.871 -91.381)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.26458 0 0 .26458 606.92 246.77)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m-2026-587.31h30v40h-30z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(7.4153)",
    style: {
      fontFeatureSettings: "normal",
      fontVariantCaps: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    },
    "aria-label": 0
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-2005.6-555.64q0 0.95703-0.3646 1.8229-0.3646 0.8431-1.0026 1.4811t-1.5039 1.0026q-0.8431 0.36459-1.8001 0.36459h-16.338q-0.9571 0-1.8229-0.36459-0.8431-0.36458-1.4812-1.0026-0.638-0.63802-1.0026-1.4811-0.3645-0.86589-0.3645-1.8229v-23.333q0-0.95703 0.3645-1.8001 0.3646-0.86589 1.0026-1.4811 0.6381-0.63802 1.4812-1.0026 0.8658-0.38737 1.8229-0.38737h16.338q0.957 0 1.8001 0.38737 0.8659 0.36458 1.5039 1.0026 0.638 0.61523 1.0026 1.4811 0.3646 0.8431 0.3646 1.8001zm-21.009-23.333v23.333h16.338v-23.333z",
    strokeWidth: "1px",
    style: {
      fontFeatureSettings: "normal",
      fontVariantCaps: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg0);
export default __webpack_public_path__ + "static/media/0.1c1ec2c036ee8d4510213bf922167b8f.svg";
export { ForwardRef as ReactComponent };